export enum ChargeType {
    Hold = "Hold",
    Charge = "Charge",
} 